export default function getPlaceName(place = {}) {
  return `${place.displayName}, ${place.state || place.country}`
}
